import { Classification } from '@app/app/ui/classification';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { html } from '@app/engine/utils/development/formatter';
import { errorManagerInstance } from '@app/engine/utils/errorManager';
import { getEl } from '@app/engine/utils/get-el';
import { keepTrackApi } from '@app/keepTrackApi';
import { KeepTrackPlugin } from '../../engine/plugins/base-plugin';
import { EventBus } from '@app/engine/events/event-bus';
export class ClassificationBar extends KeepTrackPlugin {
    id = 'ClassificationBar';
    dependencies_ = [];
    classificationString_;
    isClassificationContainerLoaded_ = false;
    isExpanded_ = false;
    containerDomId = 'classification-container';
    textStringDomId = 'classification-string';
    containerHeight = 20;
    init() {
        super.init();
        this.classificationString_ = settingsManager.classificationStr ?? '';
    }
    updateString(classificationString = this.classificationString_, backgroundColor = '#ffffff', color = '#000000') {
        if (!this.isClassificationContainerLoaded_) {
            this.createContainer_();
        }
        if (classificationString === '') {
            getEl(this.containerDomId).style.display = 'none';
            this.updateTopMenuHeight_(false);
        }
        else {
            getEl(this.containerDomId).style.display = 'flex';
            this.updateTopMenuHeight_(true);
        }
        getEl(this.textStringDomId).innerHTML = classificationString;
        const classificationContainerDom = getEl(this.containerDomId);
        classificationContainerDom.style.fontWeight = '500';
        if (Classification.isValidClassification(classificationString)) {
            const colors = Classification.getColors(classificationString);
            backgroundColor = colors.backgroundColor;
            color = colors.color;
        }
        classificationContainerDom.style.backgroundColor = backgroundColor;
        classificationContainerDom.style.color = color;
        this.classificationString_ = classificationString;
    }
    addHtml() {
        super.addHtml();
        EventBus.getInstance().on(EventBusEvent.uiManagerInit, this.uiManagerInit_.bind(this));
    }
    createContainer_() {
        const node = document.createElement('div');
        node.innerHTML = html `<span id="${this.textStringDomId}"></span>`;
        node.id = this.containerDomId;
        node.style.cssText = `
      height: ${this.containerHeight}px;
      display: flex;
      align-items: center;
      justify-content: center;
      `;
        keepTrackApi.containerRoot.insertBefore(node, keepTrackApi.containerRoot.firstChild);
        this.isClassificationContainerLoaded_ = true;
    }
    uiManagerInit_() {
        if (settingsManager.classificationStr !== '') {
            this.createContainer_();
            this.updateString();
        }
        else {
            errorManagerInstance.debug('Classification string is empty so not loading classification bar');
        }
    }
    updateTopMenuHeight_(isExpanded) {
        if (this.isExpanded_ === isExpanded) {
            return;
        }
        document.documentElement.style.setProperty('--classification-bar-height', `${isExpanded ? this.containerHeight : -this.containerHeight}px`);
        this.isExpanded_ = isExpanded;
    }
}
export const classificationBarPlugin = new ClassificationBar();
